import { render } from "./Tnved.vue?vue&type=template&id=908f0986&scoped=true"
import script from "./Tnved.vue?vue&type=script&lang=js"
export * from "./Tnved.vue?vue&type=script&lang=js"

import "./Tnved.vue?vue&type=style&index=0&id=908f0986&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908f0986"]])

export default __exports__